import { syncBookableSlots } from './Action'
import { bookableSlotsAdapter, selectBookableSlots } from './Selector'
import { initialState, bookableSlotsSlice } from './Slice'
import { Slot, BookableSlotsState } from './Type'

export { syncBookableSlots }
export { bookableSlotsAdapter, selectBookableSlots }
export { initialState, bookableSlotsSlice }
export type { Slot, BookableSlotsState }

export default bookableSlotsSlice.reducer
